import apiClient from 'shared/api/client';
import { API_ROUTES } from 'shared/constants/api';

export type MessageLevel = 'info' | 'success' | 'warning';
export type AudienceKind = 'user' | 'counterparty' | 'role' | 'all';

export interface Audience {
  kind: AudienceKind;
  ids?: number[];
  roles?: string[];
}

export interface MessageItem {
  id: number;            // id строки-получателя
  message_id: number;
  type: string;
  level: MessageLevel;
  title: string;
  body: string | null;
  payload: Record<string, unknown>;
  created_at: string;
  read_at: string | null;
  archived_at: string | null;
}

export interface MessageListResponse {
  data: MessageItem[];
  total: number;
  page: number;
  page_size: number;
  unread: number;
}

export interface SendMessagePayload {
  title: string;
  body?: string | null;
  level: MessageLevel;
  audience: Audience;
}

export async function fetchMessages(params: {
  status?: 'unread' | 'all' | 'archived';
  page?: number;
  page_size?: number;
} = {}): Promise<MessageListResponse> {
  const res = await apiClient.get<MessageListResponse>(API_ROUTES.messages.base, { params });
  return res.data;
}

export async function fetchUnreadCount(): Promise<number> {
  const res = await apiClient.get<{ unread: number }>(API_ROUTES.messages.unreadCount);
  return res.data.unread;
}

export async function markRead(recipientId: number): Promise<void> {
  await apiClient.post(API_ROUTES.messages.read(recipientId));
}

export async function markAllRead(): Promise<void> {
  await apiClient.post(API_ROUTES.messages.readAll);
}

export async function archiveMessage(recipientId: number): Promise<void> {
  await apiClient.post(API_ROUTES.messages.archive(recipientId));
}

export async function sendMessage(payload: SendMessagePayload): Promise<{ message_id: number; recipients: number }> {
  const res = await apiClient.post(API_ROUTES.messages.base, payload);
  return res.data;
}

export interface SentMessageItem {
  id: number;
  type: string;
  level: MessageLevel;
  title: string;
  body: string | null;
  created_at: string;
  recipients: number;
  read_count: number;
}

export interface SentListResponse {
  data: SentMessageItem[];
  total: number;
  page: number;
  page_size: number;
}

export async function fetchSent(params: { page?: number; page_size?: number } = {}): Promise<SentListResponse> {
  const res = await apiClient.get<SentListResponse>(API_ROUTES.messages.sent, { params });
  return res.data;
}
